import { FC, Suspense } from 'react'
import { Navbar } from './Navbar'
import { HomeCtas } from './HomeCtas'
import { Outlet } from 'react-router'
import { useLocation } from 'react-router-dom'
import designPoster from 'url:../assets/designs/Slava Ukraine with sco-ua tryzub.jpg'
import designLogo from 'url:../assets/designs/slava ukraine metal fundraser logo.png'

export const Layout: FC = () => {
  const location = useLocation()
  const isHome = location.pathname === '/'

  return (
    <div className='min-h-screen bg-brand-smoky text-brand-azure'>
      <Navbar />
      {isHome && (
        <section className='w-full'>
          <div className='relative overflow-hidden bg-brand-smoky/80 shadow-[0_18px_40px_rgba(0,0,0,0.35)] ring-1 ring-black/20'>
            <img
              src={designLogo}
              alt='Slava Ukraine metal fundraiser logo design'
              loading='lazy'
              className='h-full w-full object-contain'
            />
            <HomeCtas placement='overlay' />
          </div>
        </section>
      )}
      <main className='mx-auto max-w-7xl px-4 pb-24 pt-10'>
        <Suspense fallback='Loading...'>
          <Outlet />
        </Suspense>
      </main>
      {isHome && (
        <section className='w-full'>
          <div className='overflow-hidden bg-brand-smoky/80 shadow-[0_18px_40px_rgba(0,0,0,0.35)] ring-1 ring-black/20'>
            <img
              src={designPoster}
              alt='Slava Ukraine poster design'
              loading='lazy'
              className='h-full w-full object-contain'
            />
          </div>
        </section>
      )}
    </div>
  )
}
